// Copyright (c) Subzero Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

/** biome-ignore-all lint/complexity/noBannedTypes: V8-specific code */

/**
 * Base error class for all frost errors.
 * All errors thrown by frost extend this class.
 */
export abstract class FrostError extends Error {
  public abstract readonly code: string;
  public readonly walletName?: string;

  public constructor(message: string, walletName?: string, options?: ErrorOptions) {
    super(message, options);
    this.name = this.constructor.name;
    this.walletName = walletName;

    // Maintains proper stack trace in V8 environments (V8-specific, not in standard ES types)
    const ErrorWithCapture = Error as typeof Error & {
      captureStackTrace?: (target: object, constructorOpt?: Function) => void;
    };
    if (ErrorWithCapture.captureStackTrace) {
      ErrorWithCapture.captureStackTrace(this, this.constructor);
    }
  }
}

/** Type guard to check if an error is a FrostError */
export function isFrostError(error: unknown): error is FrostError {
  return error instanceof FrostError;
}
